import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const ArrowRight: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M22.3 10.3a1 1 0 0 1 1.4 0l5 5a1 1 0 0 1 0 1.4l-5 5a1 1 0 0 1-1.4-1.4l3.29-3.3H4a1 1 0 1 1 0-2h21.59l-3.3-3.3a1 1 0 0 1 0-1.4Z"
    />
  </Icon>
);
